import { AnalyticsEvent } from "../analytics_types.js";
import { AnalyticsTransport } from "./analytics_transport.js";

export class FanoutAnalyticsTransport implements AnalyticsTransport
{
  private readonly transports: readonly AnalyticsTransport[];

  constructor( transports: readonly AnalyticsTransport[] )
  {
    this.transports = transports;
  }

  async send( event: AnalyticsEvent ): Promise<void>
  {
    const results = await Promise.allSettled( this.transports.map( t => t.send( event ) ) );
    const first_rejection = results.find( r => r.status === 'rejected' ) as PromiseRejectedResult | undefined;
    if ( first_rejection ) throw first_rejection.reason;
  }
}

